/* eslint-disable react/prop-types */
import React from "react";
import { useTranslation } from "react-i18next";
import Drawer from "@material-ui/core/Drawer";
import ModalHeader from "../../../components/ModalHeader";
import Accordion from "../../../components/Accordion/Accordion";
import InputDrawerStatusPanel from "./InputDrawerStatusPanel";
import InputDrawerDetailsPanel from "./InputDrawerDetailsPanel";

export default function InputDrawer({
  open,
  onClose,
  isUploading,
  input,
  selectedMonthData,
  pipelineInProgress,
  getDate,
  classes,
  userDetails,
  specialOptionsApi,
  inputsStatus,
  selectStyles,
  usersList,
  fileInputRef,
  drawerUi,
  drawerActions,
}) {
  const { t, i18n } = useTranslation();
  const periodLabel = selectedMonthData
    ? getDate(
        (selectedMonthData.year * 100 + selectedMonthData.month).toString(),
        "YYYYMM",
        "MMM-YY",
      )
    : "";

  return (
    <Drawer
      anchor={"right"}
      open={open}
      onClose={onClose}
      disableEscapeKeyDown={isUploading}
      BackdropProps={{ style: { backgroundColor: "#000", opacity: "0.1" } }}
      classes={{ paper: classes.inputDrawerPaper }}
    >
      <>
        {input && (
          <>
            <ModalHeader
              title={input.input_name[i18n.language]}
              subtitleParts={[t("modeling_inputs_v2.input_details")]}
              pills={[
                periodLabel ? { key: "period", label: periodLabel } : null,
                pipelineInProgress
                  ? {
                      key: "pipeline",
                      label: t("modeling_inputs_v2.pipeline_in_progress"),
                      tone: "warning",
                      dot: true,
                    }
                  : null,
              ].filter(Boolean)}
              onClose={onClose}
              closeDisabled={isUploading}
              closeLabel={t("common.close")}
              variant="drawer"
            />
            {pipelineInProgress && (
              <div className={classes.pipelineInProgressBar}>
                {t("modeling_inputs_v2.pipeline_in_progress")}
              </div>
            )}
            <div className={classes.inputDrawerAccordionWrapper}>
              <Accordion
                collapses={[
                  {
                    title: t("modeling_inputs_v2.input_status_and_actions"),
                    content: (
                      <InputDrawerStatusPanel
                        input={input}
                        selectedMonthData={selectedMonthData}
                        userDetails={userDetails}
                        specialOptionsApi={specialOptionsApi}
                        classes={classes}
                        isUploading={isUploading}
                        fileInputRef={fileInputRef}
                        drawerUi={drawerUi}
                        drawerActions={drawerActions}
                      />
                    ),
                  },
                  {
                    title: t("modeling_inputs_v2.input_details"),
                    content: (
                      <InputDrawerDetailsPanel
                        input={input}
                        classes={classes}
                        userDetails={userDetails}
                        selectStyles={selectStyles}
                        usersList={usersList}
                        inputsStatus={inputsStatus}
                        drawerUi={drawerUi}
                        drawerActions={drawerActions}
                      />
                    ),
                  },
                ]}
                customRootClass={classes.accordionRoot}
                customTitleClass={classes.accordionTitle}
                customExpandIcon={classes.expandIcon}
                active={0}
              />
            </div>
          </>
        )}
      </>
    </Drawer>
  );
}
